export function getPriorDate(noOfDaysPrior) {
  let priorDate = new Date();
  priorDate.setDate(priorDate.getDate() - noOfDaysPrior);
  return priorDate;
}
